import { Box, Grid, Menu, MenuItem, useTheme } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { VehicleOverviewCount } from 'components/VehicleOverview/VehicleOverviewCount';
import { ReactComponent as Trailer } from 'assets/svg/home/trailer.svg';
import { ReactComponent as Truck } from 'assets/svg/home/truck_home.svg';
import { Button } from '@mui/material';
import ColumnsEditDrawer from 'components/ColumnsEditDrawer';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  fetchOverviewDetails,
  fleetOverviewSelector,
  setOverviewDetails,
  setParameters,
  setSearchResults,
  setVehicles,
  vehicleUpdatedSelector,
  filterCountSelector,
  setCount,
} from 'redux/fleets/ducks';
import CustomTable from 'components/custom/CustomTableTemp';
import i18next from 'i18next';
import { NAComponent } from '../../TireInventory/TireInventoryItems/FleetTireInventory';
import { Link } from 'react-router-dom';
import Loading from 'components/Loading';
import CommonGridItem from '../CommonGridItem';
import {
  getOverviewDetails,
  getVehicle,
  getVehicleOverviewDetails,
  getFilteredTireOverview,
} from 'services/fleet_service';
import * as XLSX from 'xlsx';
import LoadAnimation from 'components/LoadAnimation';
import { debounce } from 'lodash';
import { renderStatus } from 'utils/helper';
import { BiPencil, BiTrash } from 'react-icons/bi';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { makeStyles } from 'tss-react/mui';
import VehicleEditModal from 'pages/VehiclePage/VehicleEditModal';
import VehicleDeleteModal from 'pages/VehiclePage/VehicleDeleteModal';
import { ReactComponent as Bus } from 'assets/svg/common/busLogo.svg';
import { ReactComponent as EBus } from 'assets/svg/common/e_BusIcon.svg';
import {
  fetchVehicleOverviewColumnDisplay,
  setAccessTokenSelector,
} from 'redux/users/ducks';
import { TireOverviewFIlterDrawer } from 'components/FIlterDrawer/TireOverViewFilterDrawer';

// import {
//   ,
//   setAccessTokenSelector,
// } from 'redux/users/ducks';

const useStyles = makeStyles()(theme => {
  return {
    item: {
      display: 'flex',
      gap: 15,
    },
  };
});

const VehicleOverviewPage = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const vehicleOverview = useSelector(state => state.fleet.vehicleOverview);
  const vehicles = useSelector(state => state.fleet.vehicles);
  const bus = vehicleOverview?.bus;
  const eBus = vehicleOverview?.e_bus;
  const trailer = vehicleOverview?.trailer;
  const truck = vehicleOverview?.truck;
  const eTruck = vehicleOverview?.e_truck;
  const configurations = {
    partconfig:
      bus?.partConfig +
      trailer?.partConfig +
      truck?.partConfig +
      eTruck?.partConfig +
      eBus?.partConfig,
    fullConfig:
      bus?.fullConfig +
      trailer?.fullConfig +
      truck?.fullConfig +
      eTruck?.fullConfig +
      eBus?.fullConfig,
    unConfig:
      bus?.unConfig +
      trailer?.unConfig +
      truck?.unConfig +
      eTruck?.unConfig +
      eBus?.unConfig,
  };
  const isLoading = useSelector(state => state.fleet.isLoadingOverviewData);
  const parameters = useSelector(state => state.fleet.parameters);
  const results = useSelector(state => state.fleet.searchResults);
  const [size, setSize] = useState(null);
  const dispatch = useDispatch();
  const fleets = useSelector(fleetOverviewSelector)?.fleets;
  const [value, setValue] = useState(parameters?.vehicleTabValue || 0);

  const [params_, setParams_] = useState({
    accessing: 'ONLY_VEHICLE',
    vehicle_location: parameters?.vehicleLocation || 'fullyConfig',
    page_no: 0,
  });
  const vehicleResults = results;
  const [downloadedResources, setDownloadedResources] = useState({
    fullyConfig: null,
    partConfig: null,
    unConfig: null,
    merged: null,
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isInitial, setIsInitial] = useState(true);
  const [pageNo, setPageNo] = useState(0);
  const vehicleDataHasChanged = useSelector(vehicleUpdatedSelector);
  const [day, selectDay] = useState(5);
  const access_token = useSelector(setAccessTokenSelector);
  const count = useSelector(filterCountSelector);

  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const clearCount = () => {
    dispatch(setCount(null));
  };
  const [filterOptions, setFilterOptions] = useState([
    'fleet_name',
    'vehicle_type',
    'axle_type',
  ]);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterParameters, setFilterParameters] = useState({});
  const [checkedFilters, setCheckedFilters] = useState({});
  const [payloadFilterValues, setPayloadFilterValues] = useState(null);
  const [treadFilterValues, setTreadFilterValues] = useState({});

  const fetchFilterOptions = async () => {
    const params = {
      vehicle_location: params_.vehicle_location,
    };
    try {
      const res = await getFilteredTireOverview(params);
      let filter_options = res?.data?.resources;
      let current = Object.keys(filter_options).map(x => ({
        key: x,
      }));
      setFilterOptions(filter_options);
      current.forEach(option => {
        option.options = filter_options[option.key];

        option.hasInitialValues = filter_options[option.key]?.length
          ? true
          : false;
      });

      setSelectedFilters([]);
      setFilterParameters({});
      clearCount();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (params_.vehicle_location && access_token) {
      fetchFilterOptions();
    }
    /*eslint-disable-next-line*/
  }, [access_token, params_.vehicle_location]);

  const fetchOverview = async () => {
    const overviewDetails = await getVehicleOverviewDetails();
    dispatch(setOverviewDetails(overviewDetails));
  };

  const fetchVehiclePaginatedData = async (page, location) => {
    clearCount();
    page && setPageNo(page);
    try {
      let params;

      if (params_.vehicle_location === 'parked' || location === 'parked') {
        params = {
          accessing: 'ONLY_VEHICLE',
          vehicle_location: location || params_.vehicle_location,
          page_no: page ?? pageNo,
          per_page: rowsPerPage,
          parked_no_of_days: day,
          ...(selectedFilters.length > 0 && {
            filters: filterParameters,
          }),
        };
      } else {
        params = {
          accessing: 'ONLY_VEHICLE',
          vehicle_location: location || params_.vehicle_location,
          page_no: page ?? pageNo,
          per_page: rowsPerPage,
          ...(selectedFilters.length > 0 && {
            filters: filterParameters,
          }),
        };
      }

      dispatch(fetchOverviewDetails(params));
    } catch (error) {
      console.error('E20045');
    }
  };

  const fetchVehicles = async () => {
    clearCount();
    try {
      const params = {
        accessing: 'ONLY_VEHICLE',
        vehicle_location: params_.vehicle_location,
        page_no: 0,
        per_page: rowsPerPage,
      };
      dispatch(fetchOverviewDetails(params));
    } catch (error) {
      console.error('E20045');
    }
    setSelectedFilters([]);
    setFilterParameters({});
  };

  useEffect(() => {
    if (vehicleOverview === null && access_token) {
      fetchOverview();
    }
    // eslint-disable-next-line
  }, [access_token]);
  useEffect(() => {
    dispatch(fetchOverviewDetails(params_));

    //eslint-disable-next-line
  }, [fleets]);

  useEffect(() => {
    if (searchQuery?.length >= 2) {
      searchedDataHandler();
    }
    // eslint-disable-next-line
  }, [searchQuery]);

  useEffect(() => {
    if (!isInitial) {
      fetchVehiclePaginatedData();
    }
    // eslint-disable-next-line
  }, [rowsPerPage, isInitial]);

  const closeFilterHandler = () => {
    setOpenFilterDrawer(false);
  };

  const filterCheckChangeHandler = (e, isCheck) => {
    const value = e.target.value;
    const isChecked = e.target.checked;
    const key = e.target.name;
    let obj;

    if (isCheck) {
      setSelectedFilters(prevSelectedFilters => {
        if (isChecked) {
          return [...prevSelectedFilters, value];
        } else {
          return prevSelectedFilters.filter(item => item !== value);
        }
      });
      obj = filterParameters;
      if (isChecked) {
        if (!!obj[key]) {
          obj[key] = [...obj[key], value];
        } else {
          obj[key] = [value];
        }
      } else {
        if (!!obj[key]) {
          if (obj[key]?.length > 1) {
            let temp = obj[key]?.filter(item => item !== value);
            obj[key] = temp;
          } else delete obj[key];
        }
      }
    }
    setFilterParameters(obj);
  };

  const searchedDataHandler = debounce(async () => {
    // setLoading(true);

    const params = {
      accessing: 'ONLY_VEHICLE',
      vehicle_location: params_.vehicle_location,
      search_string: searchQuery,
      ...(selectedFilters.length > 0 && {
        filters: filterParameters,
      }),
    };
    try {
      dispatch(fetchOverviewDetails(params));
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false);
    }
  }, 400);

  useEffect(() => {
    if (searchQuery) {
      searchedDataHandler();
    } else if (payloadFilterValues) {
      fetchVehiclePaginatedData();
    } else {
      fetchVehicles();
    }
    // eslint-disable-next-line
  }, [searchQuery, access_token]);

  useEffect(() => {
    return () => {
      searchedDataHandler.cancel();
    };
  }, [searchedDataHandler]);

  const filterApplyHandler = async filterValues => {
    try {
      if (
        (selectedFilters.length && Object.values(filterParameters).length) ||
        searchQuery?.length > 0
      ) {
        setPayloadFilterValues(filterValues);

        const params = {
          accessing: 'ONLY_VEHICLE',
          ...(selectedFilters.length > 0 && {
            filters: filterParameters,
          }),
          vehicle_location: params_.vehicle_location,
        };
        dispatch(fetchOverviewDetails(params));
      } else {
        setPayloadFilterValues(null);
        fetchVehicles();
      }
    } catch (err) {
      console.error(err);
    }

    // console.log('Filter Count', count)
    // setFilterCounter(Object.keys(filterValues).length);
    setOpenFilterDrawer(false);
  };

  const filterSearchHandler = (event, filter) => {
    let val = event.target.value;
    const temp = JSON.parse(JSON.stringify(filterOptions));
    if (val.length > 1) {
      const hits = filter?.options?.filter(hit => {
        const stringWithoutSpaces = hit.replace(/\s+/g, '');
        return stringWithoutSpaces.toLowerCase().includes(val);
      });
      const index = temp?.findIndex(item => item.key === filter.key);
      temp[index].options = hits;
    }
  };

  const deleteSelectedFilterHandler = item => {
    setSelectedFilters(prevSelectedFilters => {
      return prevSelectedFilters.filter(clicked => clicked !== item);
    });
    let key = '';
    let obj = filterParameters;
    Object.entries(filterParameters)?.forEach(value => {
      if (value[1]?.includes(item)) {
        key = value[0];
      }
    });
    if (!!obj[key]) {
      if (obj[key]?.length > 1) {
        let temp = obj[key]?.filter(item_ => item_ !== item);
        obj[key] = temp;
      } else delete obj[key];
    }
  };

  useEffect(() => {
    if (vehicleOverview === null && access_token) {
      fetchOverview();
    }
    // eslint-disable-next-line
  }, [access_token]);
  useEffect(() => {
    dispatch(fetchOverviewDetails(params_));

    //eslint-disable-next-line
  }, [fleets]);

  useEffect(() => {
    return () => {
      if (!window.location.pathname.includes('overview')) {
        // dispatch(setParameters(null));
        dispatch(setSearchResults(null));
      }
    };
  }, [dispatch]);

  useEffect(() => {
    const busCount = vehicleOverview?.bus?.count ?? 0;
    const eBusCount = vehicleOverview?.e_bus?.count ?? 0;
    const truckCount = vehicleOverview?.truck?.count ?? 0;
    const eTruckCount = vehicleOverview?.e_truck?.count ?? 0;
    const trailerCount = vehicleOverview?.trailer?.count ?? 0;

    const x = [];
    if (!!busCount) {
      x.push(busCount);
    }
    if (!!trailerCount) {
      x.push(trailerCount);
    }
    if (!!truckCount) {
      x.push(truckCount);
    }
    if (!!eTruckCount) {
      x.push(eTruckCount);
    }
    if (!!eBusCount) {
      x.push(eBusCount);
    }

    if (x.length > 2) {
      setSize(4);
    } else if (x.length === 2) {
      setSize(6);
    }
    if (x.length > 4) {
      setSize(2);
    }
  }, [vehicleOverview]);

  const partial =
    vehicleOverview?.bus?.partConfig +
    vehicleOverview?.trailer?.partConfig +
    vehicleOverview?.truck?.partConfig +
    (vehicleOverview?.e_truck?.partConfig || 0) +
    (vehicleOverview?.e_bus?.partConfig || 0);

  const full =
    vehicleOverview?.bus?.fullConfig +
    vehicleOverview?.trailer?.fullConfig +
    vehicleOverview?.truck?.fullConfig +
    (vehicleOverview?.e_truck?.fullConfig || 0) +
    (vehicleOverview?.e_bus?.fullConfig || 0);

  const unconfig =
    vehicleOverview?.bus?.unConfig +
    vehicleOverview?.trailer?.unConfig +
    vehicleOverview?.truck?.unConfig +
    (vehicleOverview?.e_truck?.unConfig || 0) +
    (vehicleOverview?.e_bus?.unConfig || 0);

  useEffect(() => {
    if (!isInitial) {
      fetchVehiclePaginatedData();
    }
    // eslint-disable-next-line
  }, [rowsPerPage, isInitial, vehicleDataHasChanged]);
  useEffect(() => {
    if (value === 6) {
      fetchVehiclePaginatedData(0, 'parked');
    }

    // eslint-disable-next-line
  }, [day]);

  const vehicleData = [
    {
      label: t('common.configured'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'fullyConfig' && count !== null
              ? count
              : full
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'CONFIGURED'}
        />
      ),
      id: 'fullyConfig',
      count:
        params_.vehicle_location === 'fullyConfig' && count !== null
          ? count
          : full,
    },
    {
      label: t('common.partialConfig'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'partConfig' && count !== null
              ? count
              : partial
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'PARTIALLY_CONFIGURED'}
        />
      ),
      id: 'partConfig',
      count:
        params_.vehicle_location === 'partConfig' && count !== null
          ? count
          : partial,
    },
    {
      label: t('homePage.unconfigured'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'unConfig' && count !== null
              ? count
              : unconfig
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'UN_CONFIGURED'}
        />
      ),
      id: 'unConfig',
      count:
        params_.vehicle_location === 'unConfig' && count !== null
          ? count
          : unconfig,
    },
    {
      label: t('homePage.overdue'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'overdueFleetcheck' && count !== null
              ? count
              : vehicleOverview?.overdueFleetcheckCount
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'OVERDUE'}
        />
      ),
      id: 'overdueFleetcheck',
      count:
        params_.vehicle_location === 'overdueFleetcheck' && count !== null
          ? count
          : vehicleOverview?.overdueFleetcheckCount,
    },
    {
      label: t('homePage.merged'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'merged' && count !== null
              ? count
              : vehicleOverview?.truck?.merged
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'MERGED'}
        />
      ),
      id: 'merged',
      count:
        params_.vehicle_location === 'merged' && count !== null
          ? count
          : vehicleOverview?.truck?.merged,
    },
    {
      label: t('homePage.nonCompliant'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'nonCompliant' && count !== null
              ? count
              : vehicleOverview?.nonCompliantCount
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'NON_COMPLIANT'}
        />
      ),
      id: 'nonCompliant',
      count:
        params_.vehicle_location === 'nonCompliant' && count !== null
          ? count
          : vehicleOverview?.nonCompliantCount,
    },
    {
      label: t('homePage.parked'),
      component: (
        <VehicleTable
          vehicles={vehicles}
          fetchPaginatedData={fetchVehiclePaginatedData}
          count={
            params_.vehicle_location === 'parked' && count !== null
              ? count
              : vehicleOverview?.parkedCount
          }
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'PARKED'}
        />
      ),
      id: 'parked',
      count:
        params_.vehicle_location === 'parked' && count !== null
          ? count
          : vehicleOverview?.parkedCount,
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setParams_({
      ...params_,
      vehicle_location: vehicleData[newValue].id,
      accessing: 'ONLY_VEHICLE',
    });
    dispatch(
      setParameters({
        vehicleTabValue: newValue,
        vehicleLocation: vehicleData[newValue].id,
        accessing: 'ONLY_VEHICLE',
      })
    );
    dispatch(setVehicles([]));
    fetchVehiclePaginatedData(0, vehicleData[newValue].id);
    // if (vehicleData[newValue].count) {
    //   fetchVehiclePaginatedData(0, vehicleData[newValue].id);
    // }
  };

  const renderFilterDrawer = () => {
    if (openFilterDrawer) {
      return (
        <TireOverviewFIlterDrawer
          data-hook='filter-drawer'
          open={openFilterDrawer}
          closeHandler={closeFilterHandler}
          filters={filterOptions}
          selectedFilters={selectedFilters}
          filterParameters={filterParameters}
          checkedFilters={checkedFilters}
          setCheckedFilters={setCheckedFilters}
          setSelectedFilters={setSelectedFilters}
          setFilterParameters={setFilterParameters}
          handleChange={filterCheckChangeHandler}
          apply={filterApplyHandler}
          deleteHandler={deleteSelectedFilterHandler}
          filterSearchHandler={filterSearchHandler}
          treadFilterValues={treadFilterValues}
          setTreadFilterValues={setTreadFilterValues}
        />
      );
    }
  };

  if (!vehicles) {
    return <Loading />;
  }

  return (
    <>
      <div style={{ maxHeight: '80vh' }}>
        {isDownloading && (
          <LoadAnimation
            loading={isDownloading}
            setLoading={setIsDownloading}
            useMultiple={true}
          />
        )}

        <Grid container spacing={2}>
          {!!truck?.count && (
            <VehicleOverviewCount
              src={<Truck stroke={theme.palette.primary.main} />}
              showIcon={configurations.partconfig}
              count={truck?.count}
              name={t('common.truck')}
              size={size}
            />
          )}
          {!!eTruck?.count && (
            <VehicleOverviewCount
              src={<Truck stroke={theme.palette.primary.main} />}
              showIcon={configurations.partconfig}
              count={eTruck?.count}
              name={t('common.eTruck')}
              size={size}
            />
          )}
          {!!trailer?.count && (
            <VehicleOverviewCount
              src={<Trailer fill={theme.palette.primary.main} />}
              showIcon={configurations.partconfig}
              count={trailer?.count}
              name={t('common.trailer')}
              size={size}
            />
          )}
          {!!bus?.count && (
            <VehicleOverviewCount
              src={<Bus width={45} fill={theme.palette.primary.main} />}
              showIcon={configurations.partconfig}
              count={bus?.count}
              name={t('common.bus')}
              size={size}
            />
          )}
          {!!eBus?.count && (
            <VehicleOverviewCount
              src={<EBus width={45} fill={theme.palette.primary.main} />}
              showIcon={configurations.partconfig}
              count={eBus?.count}
              name={t('common.eBus')}
              size={size}
            />
          )}
        </Grid>
        <Grid container marginTop={'24px'}>
          <CommonGridItem
            count={count}
            setOpenFilterDrawer={setOpenFilterDrawer}
            filterCounter={selectedFilters.length}
            title={t('common.vehicleOverview')}
            currentTab={value}
            tabs={vehicleData}
            handleChange={handleChange}
            overview={vehicleOverview}
            setSearchQuery={setSearchQuery}
            results={vehicleResults}
            day={day}
            selectDay={selectDay}
            downloadResources={() =>
              fetchAllResources(
                vehicleData,
                value,
                count,
                downloadedResources,
                setDownloadedResources,
                'ONLY_VEHICLE',
                {},
                setIsDownloading
              )
            }
          />
        </Grid>
      </div>
      {renderFilterDrawer()}
    </>
  );
};

export default VehicleOverviewPage;

const VehicleTable = ({
  vehicles,
  // columns,
  fetchPaginatedData,
  count,
  loading,
  rowsPerPage,
  setRowsPerPage,
  setIsInitial,
  section,
}) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEditSelected, setIsEditSelected] = useState(false);
  const [isDeleteSelected, setIsDeleteSelected] = useState(false);
  const [vehicle, setVehicle] = useState(null);
  const [vehicleInfo, setVehicleInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeColumns, setActiveColumns] = useState([]);
  const [editColumnsIsOpen, setEditColumnsIsOpen] = useState(false);
  const columnPreference = useSelector(
    state => state.users.vehicleOverviewColumns
  );
  const access_token = useSelector(setAccessTokenSelector);
  const dispatch = useDispatch();

  const actions = {
    key: 'actions',
    title: t('tireInventoryItems.titles.actions'),
    canSort: false,
    dataHook: 'actions',
    render: (row, i) => (
      <Box
        sx={{ cursor: 'pointer' }}
        data-hook={`actions_menu-${row.vehicle_id}`}
        onClick={e => handleClick(e, row)}
      >
        <MoreVertIcon color='primary' />
      </Box>
    ),
  };
  const vehicleColumns = useMemo(
    () => [
      {
        key: 'vehicle_name',
        title: t('headers.name'),
        render: row => (
          <Link
            style={{
              textDecoration: 'none',
              padding: 5,
              color: theme.palette.primary.main,
            }}
            data-hook={`${row.vehicle_id}-vehicle`}
            color='primary'
            to={`/fleets-data/${
              row.fleet_id
            }/${row.vehicle_type.toLowerCase()}s/${row.vehicle_id}`}
          >
            <NAComponent val={row?.vehicle_name} />{' '}
            {renderStatus(row?.metadata?.interchange?.status)}
          </Link>
        ),
        size: 80,
        canSort: true,
        dataHook: 'name',
      },
      {
        key: 'fleet_name',
        title: t('headers.fleet_name'),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'fleet',
      },
      {
        key: 'fleet_id',
        title: t('headers.fleet_id'),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'fleet',
      },
      {
        key: 'vehicle_id',
        title: t('headers.vehicle_id'),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'fleet',
      },
      {
        key: 'axle_type',
        title: t('headers.axleType'),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'fleet',
      },
      {
        key: 'vehicle_type',
        title: t('fleetsSection.vehicleType'),
        render: row => (
          <span>
            {row.vehicle_type.charAt(0).toUpperCase() +
              row.vehicle_type.slice(1)}
          </span>
        ),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'vehicle-type',
      },
      {
        key: 'odometer_reading',
        title: t('headers.odometerReading'),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'fleet',
      },
      {
        key: 'inspection_date',
        title: t('headers.inspectionDate'),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'fleet',
      },
      {
        key: 'safety_check_date',
        title: t('headers.safetyCheckDate'),
        filterVariant: 'range',
        canSort: false,
        dataHook: 'fleet',
      },
      {
        key: 'reg_plate',
        title: t('headers.reg_plate'),
        filterVariant: 'range',
        canSort: false,
        dataHook: 'fleet',
      },
      {
        key: 'vin_chassis',
        title: t('headers.vin'),
        filterVariant: 'range',
        canSort: false,
        dataHook: 'fleet',
      },
      {
        key: 'uvv_check_date',
        title: t('headers.uvv_check_date'),
        filterVariant: 'range',
        canSort: false,
        dataHook: 'fleet',
      },
      {
        key: 'user_name',
        title: t('headers.last_updated_user'),
        filterVariant: 'range',
        canSort: false,
        dataHook: 'fleet',
      },
      actions,
    ],
    /*eslint-disable-next-line*/
    [i18next.language]
  );
  const shownColumns = vehicleColumns.filter(
    column => activeColumns.includes(column.key) || column.key === 'actions' // Ensure 'actions' is always included
  );
  const hiddenColumns = vehicleColumns.filter(
    column => !activeColumns.includes(column.key) && column.key !== 'actions' // Prevent hiding 'actions'
  );

  const [items, setItems] = useState({
    list1: shownColumns,
    list2: hiddenColumns,
  });

  useEffect(() => {
    const getColumnPreference = async () => {
      dispatch(
        fetchVehicleOverviewColumnDisplay(`VEHICLE_OVERVIEW_${section}`)
      );
    };

    if (access_token) {
      getColumnPreference();
    }
    // eslint-disable-next-line
  }, [section, access_token]);

  useEffect(() => {
    const itemsToShow = Object.entries(columnPreference || {}).reduce(
      (acc, [key, value]) => {
        if (value) acc.push(key);
        return acc;
      },
      []
    );

    itemsToShow.unshift('more');
    if (!itemsToShow.includes('actions')) {
      itemsToShow.push('actions'); // Ensure 'actions' is always included
    }

    setActiveColumns(itemsToShow);

    const hiddenColumns = vehicleColumns.filter(
      column => !itemsToShow.includes(column.key) && column.key !== 'actions' // Prevent hiding 'actions'
    );

    const shownColumns = vehicleColumns.filter(
      column => itemsToShow.includes(column.key) || column.key === 'actions' // Ensure 'actions' is always shown
    );

    setItems({
      list1: shownColumns,
      list2: hiddenColumns,
    });

    // eslint-disable-next-line
  }, [columnPreference]);
  const handleClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setVehicleInfo(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const itemClickHandler = async index => {
    if (index === 1) {
      setIsLoading(true);
      try {
        const res = await getVehicle(
          vehicleInfo.vehicle_id,
          vehicleInfo.vehicle_type
        );
        if (res.status === 200) {
          setVehicle(res.data.resource);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
        setIsEditSelected(true);
      }
    } else {
      setIsDeleteSelected(true);
    }
    handleClose();
  };
  const toggleDrawer = newOpen => () => {
    setEditColumnsIsOpen(newOpen);
  };

  return (
    <>
      <LoadAnimation loading={isLoading} />
      <Button
        variant='text'
        color='primary'
        style={{ textTransform: 'unset' }}
        onClick={() => setEditColumnsIsOpen(true)}
      >
        {t('columnsEdit.editBtn')}
      </Button>

      <CustomTable
        count={count}
        data={vehicles || []}
        columns={vehicleColumns}
        emptyMessage={'No vehicles available'} // Use translation for better localization
        paginationHandler={fetchPaginatedData}
        freq={count}
        loading={loading}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        isInitialRun={setIsInitial}
        revealedColumns={activeColumns.filter(
          item => item !== 'multi' || item !== 'actions'
        )} // Ensure 'actions' is always shown
        total={count}
      />

      <ColumnsEditDrawer
        items={{
          list1: items.list1,
          list2: items.list2.filter(col => col.key !== 'actions'), // Prevent hiding 'actions'
        }}
        setItems={setItems}
        setActiveColumns={setActiveColumns}
        editColumnsIsOpen={editColumnsIsOpen}
        toggleDrawer={toggleDrawer}
        section={`VEHICLE_OVERVIEW_${section}`}
      />
      <Menu
        id='select-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          className={classes.item}
          onClick={() => itemClickHandler(1)}
          data-hook='edit-icon'
        >
          <BiPencil size={20} style={{ opacity: 0.5 }} />
          <span>{t('fleetsSection.edit')}</span>
        </MenuItem>
        <MenuItem
          className={classes.item}
          onClick={() => itemClickHandler(2)}
          data-hook='delete-icon'
        >
          <BiTrash size={20} style={{ opacity: 0.5 }} />
          <span>{t('fleetsSection.delete')}</span>
        </MenuItem>
      </Menu>

      {isEditSelected && vehicle && (
        <VehicleEditModal
          data-hook='vehicle-edit-modal'
          open={isEditSelected}
          vehicle={vehicle}
          setOpen={setIsEditSelected}
          caller='overview'
          isMerged={vehicle?.isCoupled}
          postSubmitAction={() => setIsInitial(false)}
        />
      )}
      {isDeleteSelected && (
        <VehicleDeleteModal
          data-hook='vehicle-delete-modal'
          open={isDeleteSelected}
          setOpen={setIsDeleteSelected}
          vehicle={vehicleInfo}
          caller='overview'
        />
      )}
    </>
  );
};

export const fetchAllResources = async (
  data,
  value,
  count,
  downloadedResorces,
  setDownloadedResorces,
  entry,
  overview = {},
  setLoading
) => {
  let params =
    entry === 'ONLY_VEHICLE'
      ? {
          accessing: entry,
          vehicle_location: data[value].id,
          per_page: count !== null ? count : data[value].count,
        }
      : {
          accessing: entry,
          tire_location: data[value].id,
          per_page: count !== null ? count : overview?.[data[value].category],
        };
  let toDownload;
  try {
    setLoading(true);
    const res = await getOverviewDetails(params);
    if (res.status === 200) {
      toDownload = res.data.resources.map((item, i) => {
        if (item?.uvv_check_date === null) {
          return {
            ...item,
            uvv_check_date: 'N/A',
          };
        }
        if (item?.estimated_wear_out_date === null) {
          return {
            ...item,
            estimated_wear_out_date: 'N/A',
          };
        }
        return item;
      });

      setDownloadedResorces({
        ...downloadedResorces,
        [data[value].id]: toDownload,
      });
    }
  } catch (error) {
    console.error('E20111', error);
  } finally {
    setLoading(false);
  }
  toDownload = toDownload.map(obj => {
    Object.keys(obj).forEach(key => {
      if (obj[key] === null) {
        delete obj[key];
      }
    });
    return obj;
  });
  if (toDownload.length > 0) {
    const ws = XLSX.utils.json_to_sheet(toDownload);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
    XLSX.writeFile(workbook, `${data[value].label}.xlsx`);
  }
};
